var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-switch',{staticClass:"ma-0",attrs:{"hide-details":"","dense":""},on:{"click":_setup.toggleTheme},model:{value:(_setup.vuetify.theme.dark),callback:function ($$v) {_vm.$set(_setup.vuetify.theme, "dark", $$v)},expression:"vuetify.theme.dark"}})
}
var staticRenderFns = []

export { render, staticRenderFns }